import { Box, Button, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import {
  EScanToEarnProgressions,
  useScanToEarnContext,
} from '../form-wrapper/scan-to-earn-context.component'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ETranslationNs } from 'src/types'
import { IScanToEarnCreateForm } from 'src/types/scan-to-earn.type'

import { TextInputWithHelper } from 'src/components/text-input-with-helper-icon'

import { useStyles } from '../styles'

export const AddManuallyProgression = () => {
  const [t] = useTranslation(ETranslationNs.ScanForm)
  const theme = useTheme()
  const classes = useStyles()

  const { progression, setProgression } = useScanToEarnContext()
  const { handleChange, values, setFieldValue, errors, handleBlur, touched } =
    useFormikContext<IScanToEarnCreateForm>()

  const handleBackClick = () => {
    setProgression(EScanToEarnProgressions.CAMERA)
    setFieldValue('barcode_value', '')
  }

  const handleAddManuallyClick = () => {
    if (values.barcode_value && !Number.isNaN(values.barcode_value)) {
      setProgression(EScanToEarnProgressions.ADD_MEDIA)
    }
  }

  if (progression !== EScanToEarnProgressions.ADD_MANUALLY) {
    return null
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          maxWidth: '400px',
          alignItems: 'center',
          gap: '15px',
        }}
      >
        <Box
          sx={{
            fontSize: '24px',
            fontWeight: 700,
            position: 'relative',
            display: 'inline-block',
          }}
        >
          <HelperWrapper t="scan-to-earn-header-title" ns={ETranslationNs.Navbar} />
          <Typography
            sx={{
              position: 'absolute',
              top: '2px',
              right: '-35px',
              fontStyle: 'italic',
              fontSize: '10px',
              fontWeight: 700,
              color: theme.palette.custom.primary,
            }}
          >
            ALPHA
          </Typography>
          {/* <sup className={classes.supText}>ALPHA</sup> */}
        </Box>
        <Typography
          sx={{ color: theme.palette.custom.grey2, textAlign: 'center', p: '0 10px', mb: '15px' }}
        >
          <HelperWrapper t={'scan-to-earn-add-barcode-manually-text'} ns={ETranslationNs.Common} />
        </Typography>
        <TextInputWithHelper
          inputName="barcode_value"
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.barcode_value}
          error={
            touched.barcode_value && errors.barcode_value ? t(errors.barcode_value + '.v') : ''
          }
          inputUpperLabel={
            <HelperWrapper
              t={'scan-to-earn-barcode-input-label'}
              ns={ETranslationNs.Common}
              isInputLable
              isMandatory
            />
          }
          inputPlaceholder={t('scan-to-earn-barcode-input-placeholder.v', {
            ns: ETranslationNs.Common,
          })}
        />
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '30px',
          mb: '40px',
        }}
      >
        <Button onClick={handleBackClick} variant="contained" size="small">
          <HelperWrapper t="scan-to-earn-back-button-label" isColorInherited />
        </Button>
        <Button
          disabled={!values.barcode_value}
          variant="contained"
          size="small"
          onClick={handleAddManuallyClick}
        >
          <HelperWrapper t="scan-to-earn-continue-button-label" isColorInherited />
        </Button>
      </Box>
    </Box>
  )
}
